import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { SidenavService , SidenavService as SidenavMenuService } from './services/sidenav.service';
import { InitializeStore } from '../shared/functions/store.functions';
import { AppState } from './models/app.model';
import { appStateConfig } from '../config/app.config';
import { AuthState, authStateConfig } from './models/auth.model';
import { actionStateConfig, JWTState, jwtStateConfig } from './models/jwt.model';
import { CookieService } from './services/cookie.service';
import { JwtService } from './services/jwt.service';
import { MatDialogModule } from '@angular/material/dialog';
import { RoutingService } from './services/routing.service';
import { BottomSheetService } from './services/bottom-sheet.service';
import { ScreenService } from './services/screen.service';
import { provideQueryService, QueryService } from './services/query.service';
import { provideQuerySentrynelService, QuerySentrynelService } from './services/query-sentrynel.service';
import { RoleState, roleStateConfig } from './models/role.model';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LoaderService } from './services/loader.service';
import { UtentiService } from './services/utenti.service';
import { IApiKey } from './models/api-key.model';
import { IUserRole, IUtente } from './models/utenti.model';
import { APIKEY_ENDPOINT, apiKeyStateConfig } from '../config/amministrazione.config';
import { UTENTI_ENDPOINT, utentiStateConfig } from '../config/utenti.config';
import { USERROLES_ENDPOINT, userRolesStateConfig } from '../config/user-role.config';
import { KeycloakService } from 'keycloak-angular';
import { NotificationService } from './services/notification.service';
import { InterfaceNotificationApiService } from './services/interface-notification-api.service';
import { notificationDropdownStateConfig } from '../layouts/full/vertical/header/notification.config';
import { Notifications, NotificationsUtente } from '../layouts/full/vertical/header/notification.model';
import { ActionState } from './models/actions.model';
import { CoordinateService } from './services/coordinate.service';
import { COORDINATE_ENDPOINT, coordinateStateConfig } from '../config/coordinate.config';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatDialogModule,
    MatSnackBarModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    ...InitializeStore<AppState>('app-store', appStateConfig),
    ...InitializeStore<JWTState>('jwt-store', jwtStateConfig),
        ...InitializeStore<ActionState>('action-store', actionStateConfig),
    ...InitializeStore<AuthState>('auth-store', authStateConfig),
    ...InitializeStore<RoleState>('role-store', roleStateConfig),
    ...InitializeStore<NotificationsUtente>('notification-store', notificationDropdownStateConfig),
    ...provideQueryService<IApiKey>(APIKEY_ENDPOINT, apiKeyStateConfig),
    ...provideQuerySentrynelService<IUtente>(UTENTI_ENDPOINT, utentiStateConfig),
    ...provideQueryService<IUserRole>(USERROLES_ENDPOINT, userRolesStateConfig),
        ...provideQuerySentrynelService<any>(COORDINATE_ENDPOINT, coordinateStateConfig),
    ScreenService,
    CookieService,
    ApiService,
    NotificationService,
    InterfaceNotificationApiService,
    QueryService,
    SidenavService,
    LoaderService,
    QuerySentrynelService,
    SidenavMenuService,
    BottomSheetService,
    RoutingService,
    UtentiService,
    CoordinateService
  ],
})
export class CoreModule {}
